export const AREA_UNIT = [
  { value: 'm2', label: 'm²' },
  { value: 'km2', label: 'km²' },
  { value: 'ha', label: 'ha' },
] as const;

export const STATUS = [
  { value: 'ACTIVE', label: 'Đã đăng bán', color: 'bg-green-100 text-green-600' },
  { value: 'INACTIVE', label: 'Chưa đăng bán', color: 'bg-yellow-100 text-yellow-600' },
  { value: 'DRAFT', label: 'Đang soạn thảo', color: 'bg-blue-100 text-blue-600' },
  { value: 'REJECTED', label: 'Đã bị từ chối', color: 'bg-red-100 text-red-600' },
  { value: 'LOCKED', label: 'Đã khóa', color: 'bg-gray-100 text-gray-600' },
  { value: 'NOT_MATCH', label: 'Không khớp thông tin', color: 'bg-red-100 text-red-600' },
];

export const TRANSACTION_STATUS = [
  { value: 'ACTIVE', label: 'Sẵn sàng giao dịch' },
  { value: 'INACTIVE', label: 'Không thể giao dịch' },
  { value: 'COMPLETED', label: 'Hoàn thành' },
  { value: 'CANCELLED', label: 'Đã hủy' },
  { value: 'DEACTIVE', label: 'Không được giao dịch' },
  { value: 'DRAFT', label: 'Nháp' },
  { value: 'NOT_MATCH', label: 'Không khớp thông tin' },
  { value: 'LOCKED', label: 'Giao dịch bị khóa' },
];

export const LAND_DIRECTION = [
  { value: 'north', label: 'Bắc' },
  { value: 'south', label: 'Nam' },
  { value: 'east', label: 'Đông' },
  { value: 'west', label: 'Tây' },
  { value: 'northeast', label: 'Đông Bắc' },
  { value: 'northwest', label: 'Tây Bắc' },
  { value: 'southeast', label: 'Đông Nam' },
  { value: 'southwest', label: 'Tây Nam' },
] as const;

export const LAND_EXPIRATION_PERIOD = [
  { value: 'Lâu dài', label: 'Sở hữu lâu dài' },
  { value: '5 năm', label: 'Sở hữu trong 5 năm' },
  { value: '30 năm', label: 'Sở hữu trong 30 năm' },
  { value: '50 năm', label: 'Sở hữu trong 50 năm' },
  { value: 'Chưa có', label: 'Chưa có giấy sở hữu' },
] as const;

export interface BaseAssetModel {
  assetType: AssetType;
  id: string;
  name: string;
  description: string;
  area: number;
  direction: {
    door: AssetDirection;
  };
  bedrooms: number;
  bathrooms: number;
  interior: AssetInterior;
  parkingSlots: number;
  purposeType: string[];
}

export enum AssetType {
  HOME = 'Nhà ở',
  OTHER = 'Công trình khác',
}

export enum PurposeType {
  PRIVATE_HOUSE = 'Nhà riêng',
  APARTMENT = 'Căn hộ chung cư',
  SHOP_HOUSE = 'Shop house, nhà phố thương mại',
  VILLA = 'Biệt thự, liền kề',
  TOWN_HOUSE = 'Nhà mặt phố',
}

export enum OtherPurposeType {
  WARE_HOUSE = 'Kho, Nhà xưởng',
  FARM_RESORT = 'Trang trại, khu nghỉ dưỡng',
  FORREST = 'Rừng',
}

export enum AssetDirection {
  NORTH = 'Bắc',
  SOUTH = 'Nam',
  EAST = 'Đông',
  WEST = 'Tây',
  NORTHEAST = 'Đông Bắc',
  NORTHWEST = 'Tây Bắc',
  SOUTHEAST = 'Đông Nam',
  SOUTHWEST = 'Tây Nam',
}

export enum AssetsFurniture {
  BED = 'Giường ngủ',
  TABLE = 'Bàn ăn',
  CHAIR = 'Ghế',
  SOFA = 'Sofa',
  TV = 'Tivi',
  AIR_CONDITIONER = 'Điều hòa',
  WASHING_MACHINE = 'Máy giặt',
  DISH_WASHER = 'Máy rửa bát',
  FRIDGE = 'Tủ lạnh',
  MICROWAVE = 'Lò vi sóng',
  OVEN = 'Lò nướng',
  KITCHEN = 'Tủ Bếp',
  CLOSET = 'Tủ Quần áo',
  DRESSER = 'Bàn ghế',
  WARDROBE = 'Tủ Quần áo',
  CABINET = 'Tủ Kệ',
  SHELF = 'Kệ',
  OTHER = 'Khác',
}

export enum AssetStructure {
  BRICK = 'Gạch',
  CONCRETE = 'Bê tông',
  STEEL = 'Thép',
  WOOD = 'Gỗ',
  COMPOSITE = 'Vật liệu composite',
  OTHER = 'Khác',
}

export enum AssetInterior {
  FULL = 'Đầy đủ nội thất',
  BASIC = 'Nội thất cơ bản',
  NONE = 'Không có nội thất',
}

export const AssetLevel = {
  SPECIAL: {
    name: 'Cấp Đặc Biệt',
    area: { min: 25000, max: Infinity },
    floors: { min: 51, max: Infinity },
    height: { min: 200, max: Infinity },
  },
  I: {
    name: 'Cấp I',
    area: { min: 10000, max: 25000 },
    floors: { min: 20, max: 50 },
    height: { min: 75, max: 200 },
  },
  II: {
    name: 'Cấp II',
    area: { min: 5000, max: 10000 },
    floors: { min: 8, max: 20 },
    height: { min: 28, max: 75 },
  },
  III: {
    name: 'Cấp III',
    area: { min: 1000, max: 5000 },
    floors: { min: 4, max: 8 },
    height: { min: 6, max: 28 },
  },
  IV: {
    name: 'Cấp IV',
    area: { min: 0, max: 1000 },
    floors: { min: 1, max: 4 },
    height: { min: 0, max: 6 },
  },
};

export interface HouseModel extends BaseAssetModel {
  level: string;
  floors: number;
}

export interface ApartmentModel extends BaseAssetModel {
  apartmentName: string;
  projectName: string;
  balconyDirection: AssetDirection;
}

export interface ShopHouseModel extends BaseAssetModel {
  projectName: string;
}

export interface SemiVillaModel extends BaseAssetModel {
  projectName: string;
}

export interface OtherAssetModel extends BaseAssetModel {
  otherPurposeType: string[];
  otherArea: number;
  otherFloors: number;
  structure: string;
}

export type AssetModel = Partial<
  HouseModel & ApartmentModel & ShopHouseModel & SemiVillaModel & OtherAssetModel
>;

export const AssetLabel = {
  [AssetType.HOME]: {
    purposes: 'Loại tài sản',
    nameOfApartment: 'Tên căn hộ',
    nameOfBuilding: 'Tên chung cư',
    nameOfProject: 'Tên dự án',
    buildUpArea: 'Diện tích xây dựng',
    buildingClass: 'Cấp công trình',
    floors: 'Số tầng',
    bedrooms: 'Số phòng ngủ',
    bathrooms: 'Số phòng tắm',
    balconyOrientation: 'Hướng ban công',
    furnitureType: 'Nội thất',
  },
  [AssetType.OTHER]: {
    purposes: 'Loại tài sản',
    nameOfConstruction: 'Tên công trình',
    floors: 'Số tầng',
    buildUpArea: 'Diện tích xây dựng',
    structure: 'Kết cấu',
  },
};
